import {
    FETCH_CRMDOCUMENTTYPES_BEGIN,
    FETCH_CRMDOCUMENTTYPES_SUCCESS,
    FETCH_CRMDOCUMENTTYPES_FAILURE,   
} from '../constants/document';

const initialState={
    crmDocumentTypesData: [],
    isLoading:false,
    error:"",
}


export const getDocumentsReducer = (state=initialState,action) => {
    const {type,payload}=action;
 switch(type)
 {
    case FETCH_CRMDOCUMENTTYPES_BEGIN: {
        return {
          ...state,
          isLoading: true,
          error: null,
        };
      }
    case FETCH_CRMDOCUMENTTYPES_FAILURE:
        return {
            ...initialState,
            isLoading:false,
            crmDocumentTypesData:null
        };
    case FETCH_CRMDOCUMENTTYPES_SUCCESS:
        return {
            ...initialState,
            crmDocumentTypesData:payload.crmDocumentTypesData,
            isLoading:false,
        };
    default:
        return state;
 }
}